import React from "react";
import { classnames, ActionButton, Tag } from "@culturehq/components";

import { Trans } from "app/utils";

import { TimeDiff } from "components/common/Time";

import OrganizationModal from "./OrganizationModal";

const OrganizationRow = ({ organization, onUpdate }) => (
  <tr className={classnames({ disabled: !organization.active })}>
    <td>
      <img
        className="organizations--logo"
        src={organization.logo.largeUrl}
        alt={organization.name}
      />
    </td>
    <td>
      {organization.name}
      {!organization.active && <>{" "}<Tag color="gray">Disabled</Tag></>}
    </td>
    <td>
      <TimeDiff time={organization.createdAt} />
    </td>
    <td>
      <OrganizationModal organization={organization} onUpdate={onUpdate}>
        {onTrigger => (
          <ActionButton icon="edit" onClick={onTrigger}>
            <Trans>Edit</Trans>
          </ActionButton>
        )}
      </OrganizationModal>
    </td>
  </tr>
);

export default OrganizationRow;
